import type { ReactNode } from 'react';
import { Header } from './Header';
import { Footer } from './Footer';
import { SLABanner } from './SLABanner';
import { WhatsAppButton } from './WhatsAppButton';

interface MainLayoutProps {
  children: ReactNode;
}

export function MainLayout({ children }: MainLayoutProps) {
  return (
    <div className="min-h-screen flex flex-col">
      <SLABanner />
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}
